<script setup lang="ts">
const { locales, locale, setLocale } = useI18n();

const props = defineProps(["placement"]);
const language = computed({
  get: () => locale.value,
  set: async (value) => {
    setLocale(value);

    const authStore = useUserStore();
    if (authStore.isUserLoggedIn) {
      authStore.updateUserSetting("selectedLang", value);
    }

    await refreshNuxtData();
  },
});
</script>

<template>
  <USelectMenu
    v-model="language"
    :options="locales"
    value-attribute="code"
    option-attribute="name"
    class="w-36"
    :popper="{
      placement: props.placement ?? 'bottom-start',
    }"
  />
</template>
